import { THEME_CHANGE } from "./actionTypes";

export const setTheme = (data) => (dispatch) => {
        dispatch({
            type: THEME_CHANGE,
            payload: data,
        });
    };